import React, { useEffect, useState } from 'react';

// Component used for locations on the My Retail page as well as during the add Retail process.
const Location = (props) => {
  const [editable, setEditable] = useState();
  const [memberNumber, setMemberNumber] = useState(props.location.membershipNumber?props.location.membershipNumber:'');
  // if location is editable set the state that can be used for display.
  useEffect(() => {
    setEditable(props.editable===props.location.retailID?true:false)
  }, [props.editable]);

  // Used for setting membership number.
  const handleChange = (e) => {
    var mn = memberNumber;
    mn = e.target.value
    setMemberNumber(mn)
    props.changeMembershipNumber(props.location.retailID, mn)
  }

  // Generic key press function. Depending on the key pressed another function can be invoked.
  // Used for keyboard actions for accessibility.
  const handleKeyPress = (e) => {
    if(e.key === 'Enter'){
      if (e.target.className ==='remove') {
        console.log("press remove")
        props.remove(props.location.retailID)
      }
    }
  }  

  if (editable) {
    return (
      <div className="location active" role='button'>
        {(props.location.isPrimary && props.action !=="add") ? <div>Primary Co-op</div> : ''}
        <div className="coop-name">{props.location.retailName}</div>
        <div>{props.location.retailCity ? props.location.retailCity+',':''} {props.location.retailProvince}</div>
        <div className="memberNumber">
            <label htmlFor="memberNumber">Member # (optional)</label>
            <input 
              type="text" 
              name="memberNumber" 
              id="memberNumber" 
              value={memberNumber || ''} 
              onChange={handleChange}> 
            </input>
          </div>
          <div>
            <input 
              type="checkbox" 
              name="primary" 
              aria-label="primary co-op"
              value={props.location.retailID} 
              checked={props.location.isPrimary} 
              onChange={props.changePrimary}
            />Make this my primary Co-op
          </div>
          {(props.location.isPrimary || props.action ==="add") ? '' : 
            <div 
              className="remove" 
              onClick={()=>props.remove(props.location.retailID)}
              onKeyPress={handleKeyPress}
              role='button' 
              tabIndex="0"
            ><i className="fa fa-trash fa-2x" aria-hidden="true"></i></div>}
      </div>
    )
  } else {
    return (
      <div className="location">
      <div className="location-inner closed" 
        onClick={()=>props.selectLocation(props.location.retailID)} 
        onFocus={()=>props.selectLocation(props.location.retailID)} 
        role='button' 
        tabIndex="0"
      >
        {props.location.isPrimary ? <div>Primary Co-op</div> : ''}
        <div className="coop-name">{props.location.retailName}</div>
        <div>{props.location.retailCity}, {props.location.retailProvince}</div>
        <div className="member-number">Member # {memberNumber ? memberNumber : ""}</div>
      </div>
        {props.location.isPrimary ? '' : 
          <div 
            className="remove" 
            onClick={()=>props.remove(props.location.retailID)}
          ><i className="fa fa-trash fa-2x" aria-hidden="true"></i></div>}
      </div>
    );
  }
}

export default Location;